var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-tabs-item",class:[_vm.classes],on:{"click":_vm.itemClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }